import {React, useState} from 'react';

import Draggable from 'react-draggable';
import Files from 'react-files';
import {Resizable} from 're-resizable';

const ProfileImage = ({className}) => {
  const [pic, setPic] = useState(null);

  const onFileChange = (files) => {
    if (files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setPic(reader.result);
      });
      reader.readAsDataURL(files[0]);
    }
  }

  const onFileError = (error, file) => {
    console.log('ERROR', error.message);
  }

  return (
    <div className={className}>
      { pic ? (<Draggable><Resizable
        defaultSize={{
          width: 300,
          height: 300
        }}
        style={{
          background: `url(${pic})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat'
        }}
        lockAspectRatio={true}></Resizable></Draggable>) : null }
      <Files
        className='pc-upload-file'
        onChange={onFileChange}
        onError={onFileError}
        accepts={['.jpg', '.jpeg', '.png', '.gif']}
        clickable>
        <strong>+</strong>
      </Files>
    </div>
  );
};

export default ProfileImage;
